import { connect } from 'react-redux';
import EditEntity from '../components/EntityEditing/EditEntity';

const mapStateToProps = state => ({
  loadingOverwrites: state.teamOverwrites.loading,
  writing: state.teamOverwrites.writing,
  overwrites: state.teamOverwrites.overwrites,
  writeError: state.teamOverwrites.writeError,
  fetchOverwriteError: state.teamOverwrites.error,
  currentEdits: state.edits.currentEdits,
  editsDirty: state.edits.dirty,
});

export default connect(mapStateToProps)(EditEntity);
